module.exports = __webpack_public_path__ + "img/logo_tinaba_colore_orizzontale.b7e95e37.svg";